import React from 'react'
import axios from 'axios'
import {
  isEqual,
  filter,
  map,
  startCase,
  isNull
} from 'lodash'
import {
  FilterTable,
  ContentSectionBlock,
  Link
} from 'camino-react'

import NewConcernModal from './NewConcernModal'

import LoadingSpinner from 'Components/LoadingSpinner'
import { cloudhelpPatch } from 'Utilities/CloudHelp'

class ImpactConcerns extends React.Component {
  constructor (props) {
    super(props)

    const {
      ticket,
      concerns
    } = props

    this.state = {
      ticket,
      concerns,
      showNewConcernModal: false
    }
  }

  afterSubmitNewConcerns = (concerns) => {
    this.setState({ concerns, showNewConcernModal: false })
  }

  onDeleteImpactConcern = (deletedConcern) => {
    this.setState({ processing: true })

    const { concerns } = this.state

    const updatedConcerns = filter(concerns, concern => !isEqual(concern, deletedConcern))

    const params = { concerns: updatedConcerns }

    cloudhelpPatch(`/api${window.location.pathname}/impact_concerns/update`, params)
      .then(({ data }) => { this.setState({ concerns: data, processing: false }) })
  }

  render () {
    const {
      concerns,
      processing,
      showNewConcernModal,
      ticket
    } = this.state

    const columns = [
      {
        minWidth: 200,
        Cell: ({ original }) => {
          const attributes = map(original, (value, key) => {
            if (key === 'href') { } else {
              return (
                <p key={key} className="col-11" style={{ marginBottom: '0.25rem', marginTop: '0' }}>
                  <small>
                    <b>
                      {`${startCase(key)}: `}
                    </b>
                    <br />
                    {value || <br />}
                  </small>
                </p>
              )
            }
          })

          return (
            <div className="row">
              {attributes}
            </div>
          )
        }
      },
      {
        maxWidth: 100,
        disableHref: true,
        Cell: ({ original }) => (
          <>
            <Link
              color="link"
              href={original.href}
            >
              View&nbsp;
            </Link>
            <span
              className="link link--decorated button-link"
              onClick={() => this.onDeleteImpactConcern(original)}
            >
              <i className="lnr lnr-trash" />
            </span>
          </>
        )
      }
    ]

    return (
      <section className="card">
        { processing && <LoadingSpinner withOverlay /> }
        <ContentSectionBlock
          title="Assets & Configurations"
          actions={[
            isNull(ticket.primary_ticket_id) && {
              text: 'add',
              onClick: () => { this.setState({ showNewConcernModal: true }) }
            }
          ]}
        >
          <FilterTable
            localStoragePrefix="ticket_ImpactConcerns"
            data={concerns}
            columns={columns}
          />
        </ContentSectionBlock>
        { showNewConcernModal && (
          <NewConcernModal
            showModal
            removeModal={() => this.setState({ showNewConcernModal: false })}
            ticket={ticket}
            concerns={concerns}
            afterSubmit={this.afterSubmitNewConcerns}
          />
        )}
      </section>
    )
  }
}

export default ImpactConcerns
